import React from 'react';
import PropTypes from 'prop-types';
import relationships from 'facet-rest/src/consts/relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import moment from 'moment';
import { fullDateTime } from 'Consts/DateFormats';
import { withTheme } from '@material-ui/core/styles';
import { getApexInvestigationStatusColor } from 'Consts/Apex';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';
import { useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { setInvestigationResource, setAchRelationshipResource } from '../../ApexAdminPortalActions';

const Investigations = ({
  resource: accountCreationRequestResource,
}) => {
  const apexAdminPortalDispatch = useApexAdminPortalDispatchContext();
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [investigationCollection, setInvestigationCollection] = React.useState(null);
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Investigation' });

  const fetchInvestigations = async () => {
    try {
      setLoading(true);
      const newCollection = await accountCreationRequestResource.relationship(relationships.achInvestigations.name).link('related').Get();
      setInvestigationCollection(newCollection);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };
  const refreshRows = () => {
    const newRows = [];
    // eslint-disable-next-line no-unused-expressions
    investigationCollection?.resources()?.list().forEach((investigation) => {
      newRows.push({
        status: investigation.selectedOptionPrompt('status') || '',
        statusColors: getApexInvestigationStatusColor(investigation.attr('status')),
        date: moment(investigation.attr('createdAt')).utc().format(fullDateTime),
        resource: investigation,
      });
    });
    setRows(newRows);
  };
  const onClickInvestigation = (investigationResource) => {
    setInvestigationResource(investigationResource, apexAdminPortalDispatch);
    setAchRelationshipResource(null, apexAdminPortalDispatch);
  };

  React.useEffect(() => {
    if (accountCreationRequestResource?.relationship(relationships.achInvestigations.name)) {
      fetchInvestigations();
    } else {
      setLoading(false);
    }
  }, [accountCreationRequestResource]);
  React.useEffect(() => {
    refreshRows();
  }, [investigationCollection]);

  return (
    <View
      collection={investigationCollection}
      rows={rows}
      loading={loading}
      onClickInvestigation={(investigationResource) => {
        onClickInvestigation(investigationResource);
        logEvent('Click Investigation Status');
      }}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

Investigations.propTypes = {
  resource: PropTypes.object,
};
Investigations.defaultProps = {
  resource: null,
};

export default withTheme(Investigations);
